
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.287 13.32c-2.708 0-4.912-2.195-4.912-4.892 0-2.697 2.204-4.89 4.912-4.89h.008c2.694 0 4.89 2.178 4.905 4.86v.03c-.008 2.697-2.211 4.891-4.913 4.891zm0-8.64c-2.08 0-3.772 1.684-3.772 3.748 0 2.065 1.691 3.749 3.765 3.749 2.073 0 3.764-1.684 3.764-3.749v-.023c-.007-2.057-1.69-3.725-3.757-3.725z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11.944 28H4.622C2.074 28 0 25.934 0 23.397v-2.835c0-4.548 3.719-8.25 8.287-8.25 4.568 0 8.287 3.702 8.287 8.25v2.835c-.008 2.537-2.082 4.601-4.63 4.601zM8.287 13.462c-3.933 0-7.14 3.185-7.14 7.108v2.834c0 1.905 1.562 3.46 3.475 3.46h7.322c1.913 0 3.474-1.555 3.474-3.46v-2.834c0-3.924-3.198-7.108-7.131-7.108z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.102 0c.27 0 .49.22.49.491v6.943a.49.49 0 11-.979 0V.491a.49.49 0 01.49-.491z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22 4.042a.49.49 0 01-.489.491h-6.973a.49.49 0 01-.49-.491.49.49 0 01.49-.491h6.973c.27 0 .489.22.489.491z","fill":"#fff"}})])
          )
        }
      }
    